type ComparableAufgabe = {
  status: string;
  ergebnis: string | null;
};

export const compareAufgabe = (left: ComparableAufgabe, right: ComparableAufgabe): number => {
  const byStatusOffenUndKeinErgebnis = compareByStatusOffenUndKeinErgebnis(left, right);
  if (byStatusOffenUndKeinErgebnis !== 0) {
    return byStatusOffenUndKeinErgebnis;
  }
  const byStatusOffenUndZwischenergebnis = compareByStatusOffenUndZwischenergebnis(left, right);
  if (byStatusOffenUndZwischenergebnis !== 0) {
    return byStatusOffenUndZwischenergebnis;
  }
  const byStatusAbgeschlossenUndErfolgreich = compareByStatusAbgeschlossenUndErfolgreich(left, right);
  if (byStatusAbgeschlossenUndErfolgreich !== 0) {
    return byStatusAbgeschlossenUndErfolgreich;
  }
  const byStatusAbgeschlossenUndErfolglos = compareByStatusAbgeschlossenUndErfolglos(left, right);
  if (byStatusAbgeschlossenUndErfolglos !== 0) {
    return byStatusAbgeschlossenUndErfolglos;
  }
  return 0;
};

const compareByStatusOffenUndKeinErgebnis = (left: ComparableAufgabe, right: ComparableAufgabe): number => {
  if ((left.status === 'Offen' && !left.ergebnis) && (right.status !== 'Offen' || right.ergebnis)) {
    return -1;
  }
  if ((right.status === 'Offen' && !right.ergebnis) && (left.status !== 'Offen' || left.ergebnis)) {
    return 1;
  }
  return 0;
};

const compareByStatusOffenUndZwischenergebnis = (left: ComparableAufgabe, right: ComparableAufgabe): number => {
  if (left.status === 'Offen' && right.status !== 'Offen') {
    return -1;
  }
  if (right.status === 'Offen' && left.status !== 'Offen') {
    return 1;
  }
  return 0;
};

const compareByStatusAbgeschlossenUndErfolgreich = (left: ComparableAufgabe, right: ComparableAufgabe): number => {
  if ((left.status === 'Abgeschlossen' && left.ergebnis === 'Erfolgreich') && (right.status !== 'Abgeschlossen' || right.ergebnis !== 'Erfolgreich')) {
    return -1;
  }
  if ((right.status === 'Abgeschlossen' && right.ergebnis === 'Erfolgreich') && (left.status !== 'Abgeschlossen' || left.ergebnis !== 'Erfolgreich')) {
    return 1;
  }
  return 0;
};

const compareByStatusAbgeschlossenUndErfolglos = (left: ComparableAufgabe, right: ComparableAufgabe): number => {
  if ((left.status === 'Abgeschlossen' && left.ergebnis === 'Erfolglos') && (right.status !== 'Abgeschlossen' || right.ergebnis !== 'Erfolglos')) {
    return -1;
  }
  if ((right.status === 'Abgeschlossen' && right.ergebnis === 'Erfolglos') && (left.status !== 'Abgeschlossen' || left.ergebnis !== 'Erfolglos')) {
    return 1;
  }
  return 0;
};
